/** Only saved, valid observations may be confirmed for application. */
export function stocktakeFinishState(
  rows: { counted: string; expectedQty: number; note: string }[],
  state: { owner: boolean; dirty: boolean; stale: boolean; busy: boolean },
) {
  const blocked = (message: string) => ({ full: false, partial: false, message });
  if (!state.owner) return blocked('Save the count for the owner to review and apply.');
  if (state.dirty) return blocked('Save your changes before finishing.');
  if (state.stale) return blocked('This bin changed after counting started. Cancel and start a new count.');
  if (state.busy) return blocked('Please wait for the current action to finish.');
  const counted = rows.filter((r) => r.counted !== '');
  if (counted.some((r) => !/^\d+$/.test(r.counted) || Number(r.counted) > 1_000_000)) {
    return blocked('Enter whole numbers from zero to 1,000,000.');
  }
  if (counted.some((r) => Number(r.counted) !== r.expectedQty && !r.note.trim())) {
    return blocked('A note is required for every row whose count differs.');
  }
  const uncounted = rows.length - counted.length;
  return {
    full: uncounted === 0,
    partial: counted.length > 0,
    message: rows.length === 0 ? 'Finish full to confirm this bin is empty.'
      : uncounted ? `${uncounted} rows remain uncounted and will be left unchanged by a partial count.`
      : 'Every row is counted. Ready for confirmation.',
  };
}

/**
 * The paper sheet must be blind: do not pass expected or entered quantities
 * into its view model, so neither can accidentally appear in the print layout.
 */
export function stocktakePrintRows<T extends {
  id: number;
  itemType: string;
  itemNo: string;
  itemName: string;
  colorName: string;
  condition: string;
  subCondition: string | null;
}>(rows: T[]) {
  return rows.map(({ id, itemType, itemNo, itemName, colorName, condition, subCondition }) => ({
    id, itemType, itemNo, itemName, colorName, condition, subCondition,
  }));
}
